module.exports = __webpack_public_path__ + "img/product_80.ac74a4d.webp";